/**
 * @param placement
 */
export default function getBasePlacement(placement) {
  return placement.split('-')[0];
}